module.exports = __webpack_public_path__ + "img/Gradient1-01.bac4096f.png";